import React from 'react';
import PropTypes from 'prop-types';

import IEdit from '@meronex/icons/fi/FiEdit2';
import IDelete from '@meronex/icons/fi/FiTrash2';

import { useTheme } from '@material-ui/core/styles';
import { App } from '@meronex/app';

import SitesAvatar from '../../../common/SitesAvatar';

const MemberItem = (props) => {
  const { onClick, onEditClick, onDeleteClick, member } = props;
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  const [hovered, setHovered] = React.useState(false);

  const textColor = isDark ? '#e2e8f0' : '#0f172a';
  const mutedColor = isDark ? '#94a3b8' : '#64748b';
  const borderColor = isDark ? 'rgba(255,255,255,0.06)' : '#f1f5f9';
  const hoverBg = isDark ? 'rgba(255,255,255,0.04)' : '#f8fafc';

  const getRoleName = () => {
    if (
      Array.isArray(member.roles) &&
      member.roles.some((r) => ['admin', 'root', 'manager'].includes(r))
    ) {
      return 'Admin';
    }
    if (member.settings?.sites?.role) {
      return member.settings.sites.role.name;
    }
    return '';
  };

  const roleName = getRoleName();
  const isAdmin = roleName === 'Admin';
  const memberName = `${member.profile?.firstName || ''} ${member.profile?.lastName || ''}`.trim() || 'Unknown';
  const email = member.emails?.[0]?.address || 'No email';
  const lastSeen = App.utils.time.timeAgo(member.profile?.lastLoggedIn);

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        padding: '12px 16px',
        borderBottom: `1px solid ${borderColor}`,
        cursor: 'pointer',
        backgroundColor: hovered ? hoverBg : 'transparent',
        transition: 'background-color 0.15s',
      }}
    >
      <SitesAvatar
        image={member.profile?.avatar}
        name={memberName}
        size={44}
        round={12}
      />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}>
          <span style={{
            fontSize: '14px',
            fontWeight: 600,
            color: textColor,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>
            {memberName}
          </span>
          {roleName && (
            <span style={{
              fontSize: '11px',
              fontWeight: 600,
              padding: '2px 8px',
              borderRadius: '6px',
              backgroundColor: isAdmin
                ? (isDark ? 'rgba(99,102,241,0.15)' : '#eef2ff')
                : (isDark ? 'rgba(255,255,255,0.06)' : '#f1f5f9'),
              color: isAdmin
                ? '#6366f1'
                : mutedColor,
              flexShrink: 0,
            }}>
              {roleName}
            </span>
          )}
        </div>
        <div style={{
          fontSize: '12px',
          color: mutedColor,
          marginTop: '2px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          {email}
          {lastSeen && <span> &middot; {lastSeen}</span>}
        </div>
      </div>
      {/* Action buttons — always visible */}
      <div style={{
        display: 'flex',
        gap: '4px',
        flexShrink: 0,
        opacity: hovered ? 1 : 0.3,
        transition: 'opacity 0.15s',
      }}>
        <div
          onClick={(e) => { e.stopPropagation(); onEditClick(); }}
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#6366f1',
            cursor: 'pointer',
            transition: 'background-color 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = isDark ? 'rgba(99,102,241,0.15)' : '#eef2ff'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
        >
          <IEdit size={15} />
        </div>
        <div
          onClick={(e) => { e.stopPropagation(); onDeleteClick(); }}
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: isDark ? '#f87171' : '#dc2626',
            cursor: 'pointer',
            transition: 'background-color 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = isDark ? 'rgba(248,113,113,0.1)' : '#fef2f2'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
        >
          <IDelete size={15} />
        </div>
      </div>
    </div>
  );
};

MemberItem.propTypes = {
  onClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  member: PropTypes.object,
};

MemberItem.defaultProps = {
  onClick: () => {},
  onEditClick: () => {},
  onDeleteClick: () => {},
};
export default MemberItem;
